import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

export const OrderAddress = ({ order }) => {
  const address = {
    // Contact: order.contact,
    // Email: order.email,
    // Phone: order.mobileNo,
    Name: order.shiptoName,
    "Address 1": order.shiptoAddrs1,
    "Address 2": order.shiptoAddrs2,
    City: order.shiptoCity,
    County: order.shiptoCounty,
    Postcode: order.shiptoPostCode,
    // Country: order.shiptoCountry,
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Address
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        {Object.entries(address).map(([key, value], i) => (
          <Grid
            key={key}
            size={{
              xs: 2,
              sm: 4,
              md: 4,
            }}
          >
            <TextField
              size="small"
              fullWidth
              id={`${key}-input`}
              label={key}
              value={value || ""}
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Grid>
        ))}
        {/* <Grid
          xs={2}
          sm={4}
          md={4}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <FormControlLabel
            disabled
            control={<Switch checked={order.homeaddress} />}
            label="Residential"
          />
        </Grid> */}
      </Grid>
    </Paper>
  );
};
